import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #FFFFFF;
    font-family: Mulish;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 20px 20px 16px;
    border-bottom: 1px solid #EEF1F6;
`;

export const Title = styled.h3`
    margin: 0;
    color: #2B3240;
    font-size: 1rem;
    font-weight: 800;
`;

export const SearchBar = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 16px 16px 14px;
    padding: 12px 16px;
    background: #EEF1F6;
    border-radius: 12px;
    color: #9AA4B2;

    /* lupa à direita do campo */
    svg { font-size: 1.05rem; flex: 0 0 auto; }
`;

export const SearchInput = styled.input`
    border: none;
    background: transparent;
    outline: none;
    flex: 1;
    color: #2B3240;
    font-size: 0.85rem;
    font-family: Mulish;

    &::placeholder { color: #9AA4B2; }
`;

export const Filters = styled.div`
    display: flex;
    gap: 8px;
    padding: 0 16px 8px;
`;

export const Filter = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 7px;
    border: none;
    background: ${(props) => (props.$active ? "#EAF2FF" : "#EEF1F6")};
    color: ${(props) => (props.$active ? "#2F80ED" : "#4B5563")};
    font-family: Mulish;
    font-size: 0.82rem;
    font-weight: 700;
    padding: 6px 12px;
    border-radius: 16px;
    cursor: pointer;
`;

export const Badge = styled.span`
    background: #FFFFFF;
    color: #6B7280;
    border-radius: 10px;
    min-width: 18px;
    padding: 0 7px;
    text-align: center;
    font-size: 0.72rem;
    font-weight: 700;
`;

export const List = styled.div`
    flex: 1;
    overflow-y: auto;
    padding: 4px 8px 12px;

    ::-webkit-scrollbar { width: 8px; }
    ::-webkit-scrollbar-thumb { background-color: #BABABA; border-radius: 5px; }
`;

export const State = styled.div`
    padding: 24px 12px;
    text-align: center;
    color: #8A94A6;
    font-size: 0.85rem;
`;
